var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.projectItem
    ? _c(
        "div",
        { staticClass: "w-full flex" },
        [
          _c(
            "Tooltip",
            {
              attrs: {
                title: _vm.tooltipTitle,
                variant: _vm.TooltipVariants.DARK,
                tooltipClasses: "w-60",
                placement: "top",
              },
            },
            [
              _vm.colorCode
                ? _c("ColorCodeTriangle", {
                    attrs: { colorCode: _vm.colorCode },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "flex w-full", class: _vm.avatarsPadding }, [
            _vm.contractorsExist
              ? _c(
                  "div",
                  { staticClass: "flex self-center flex-shrink-0 mr-4" },
                  _vm._l(_vm.contractors, function (contractor) {
                    return _c("SchedulerItemAvatar", {
                      key: contractor.id,
                      staticClass: "-mr-2",
                      attrs: {
                        avatar: contractor.avatar,
                        title: _vm.getContractorName(contractor),
                      },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "text-white truncate mr-4 text-sm" }, [
              _c("div", { staticClass: "font-bold truncate" }, [
                _vm._v(_vm._s(_vm.projectName)),
              ]),
              _c("div", { staticClass: "truncate" }, [
                _vm._v("Activites: " + _vm._s(_vm.projectActivitiesNumber)),
              ]),
            ]),
          ]),
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "flex items-center new-activity" },
        [
          _c("span", { staticClass: "mr-4 text-white text-sm font-semibold" }, [
            _vm._v("New Project"),
          ]),
          _c("UiButton", {
            attrs: { buttonText: "Create", variant: "outline", size: "xxs" },
            on: {
              click: function ($event) {
                return _vm.$emit("create", _vm.project)
              },
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }